<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid ">
    <!-- zona de filtros -->
    <div class="row m-t-md">
      <div class="col-12">
        <p-panel>
          <p-header>
            <span>{{'General.filters' | translate}}</span>
          </p-header>
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-3">
                  <formElement [model]="filters" name="from" [fieldConfig]="getFieldConfig(this.FROM_PARAM)" #ref>
                  </formElement>
                </div>
                <div class="col-3">
                  <formElement [model]="filters" name="to" [fieldConfig]="getFieldConfig(this.TO_PARAM)" #ref>
                  </formElement>
                </div>
                <div class="col-6">
                  <formElement [model]="filters" id="actionType" name="actionType"
                    [fieldConfig]="getFieldConfig(this.ACTIONTYPE_PARAM)" #ref>
                  </formElement>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <formElement [model]="filters" name="user" [fieldConfig]="getFieldConfig(this.USER_PARAM)" #ref>
                  </formElement>
                </div>
                <div class="col-6">
                  <formElement [model]="filters" name="messageType"
                    [fieldConfig]="getFieldConfig(this.MESSAGETYPE_PARAM)" #ref>
                  </formElement>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="titleElement"> Documento relacionado
                  </div>
                </div>
                <div class="col-3">
                  <formElement [model]="filters" name="dossierId" [fieldConfig]="getFieldConfig(this.DOSSIER_PARAM)"
                    #ref>
                  </formElement>
                </div>
                <div class="col-3">
                  <formElement [model]="filters" name="documentClassId"
                    [fieldConfig]="getFieldConfig(this.DOCUMENTCLASS_PARAM)" #ref>
                  </formElement>
                </div>
                <div class="col-3">
                  <formElement [model]="filters" name="division" [fieldConfig]="getFieldConfig(this.DIVISION_PARAM)"
                    #ref>
                  </formElement>
                </div>
                <div class="col-3">
                  <formElement [model]="filters" name="orderNumber"
                    [fieldConfig]="getFieldConfig(this.ORDERNUMBER_PARAM)" #ref>
                  </formElement>
                </div>
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-primary btn-xs  float-right m-b-md" (click)="search(false)" type="button"><i
                  class="fas fa-search"></i> {{'General.search.text' |
                translate}} </button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-12">
        <!-- zona de datos -->
        <p-panel>
          <p-header>
            <span class="m-xst float-right m-l-md leyenda" *ngIf="events">
              {{'General.search.showing'|translate}} {{ events.length }} <span
                *ngIf="pageInfo && pageInfo.totalElements > 0"> {{'General.search.showing1'|translate}} {{
                pageInfo.totalElements }}</span></span>
          </p-header>
          <p-table #dt [value]="events" sortField="audFileMessage.date" sortOrder="-1" [scrollable]="false"
            [resizableColumns]="true" class="footer-over-pagination" [paginator]="false" [pageLinks]="5"
            [first]="pageInfo.number * pageInfo.size" [rows]="pageInfo.size" dropdownAppendTo="body"
            [totalRecords]="pageInfo.totalElements" [rowsPerPageOptions]="[10, 25, 50, 100]"
            (onPage)="reloadEvents($event)">
            <tr>
              <td [attr.colspan]="6"> No se han encontrado sucesos </td>
            </tr>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="audFileMessage.date" styleClass="col-2">Fecha <p-sortIcon
                    field="audFileMessage.date"></p-sortIcon>
                </th>
                <th pSortableColumn="user.identifier" styleClass="col-2">Usuario <p-sortIcon
                    field="user.identifier"></p-sortIcon>
                </th>
                <th pSortableColumn="audOperation.actionType" styleClass="col-2">Tipo Acción <p-sortIcon
                    field="audOperation.actionType"></p-sortIcon>
                </th>
                <th pSortableColumn="audFileMessage.messageType" styleClass="col-2">Tipo Mensaje <p-sortIcon
                    field="audFileMessage.messageType"></p-sortIcon>
                </th>
                <th pSortableColumn="division.project.identifier" styleClass="col-2">Documento <p-sortIcon
                    field="division.project.identifier"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-event>
              <tr>
                <td class="TEXTTH-w100">
                  <formatDataValue [type]="'TEXT'"
                    [*ngIf]="event != null && event.audFileMessage != null && event.audFileMessage.date != null"
                    [value]="event?.audFileMessage?.date | date: 'dd/MM/yyyy HH:mm:ss'">
                  </formatDataValue>
                </td>
                <td class="TEXTTH-w100">
                  <formatDataValue [type]="'TEXT'" [value]="event.userDescription">
                  </formatDataValue>
                </td>
                <td class="TEXTTH-w100">
                  <formatDataValue [type]="'TEXT'"
                    [*ngIf]="event != null && event.audOperation != null && event.audOperation.actionType != null"
                    [value]="event.audOperation.actionType">
                  </formatDataValue>
                </td>
                <td class="TEXTTH-w100">
                  <formatDataValue [type]="'TEXT'"
                    [*ngIf]="event != null && event.audFileMessage != null && event.audFileMessage.messageType != null"
                    [value]="event.audFileMessage.messageType">
                  </formatDataValue>
                </td>
                <td class="TEXTTH-w100">
                  <formatDataValue [type]="'TEXT'" [value]="event?.documentDescription">
                  </formatDataValue>
                </td>
                <td>
                  <div class="d-flex justify-content-center">
                    <div class="btn-group">
                      <button class="btn btn-sm btn-primary t-action-button" (click)="viewDocument(event)"
                        aria-expanded="false" title="Ver">
                        <i class="fas fa-eye" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr class="text-center">
                <td [attr.colspan]="4" style="padding: 0; margin: 0; border: 0">
                  <p-paginator [rows]="pageInfo.size" [first]="pageInfo.number * pageInfo.size" dropdownAppendTo="body"
                    [totalRecords]="pageInfo.totalElements" [rowsPerPageOptions]="[10, 25, 50, 100]"
                    (onPageChange)="reloadEvents($event)"></p-paginator>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2">No hay sucesos disponibles para los filtros aplicados</td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
</div>